export default __webpack_public_path__ + "static/media/signin_background_latest.721df13a.svg";